import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LanguageInterceptor } from './language.interceptor';
import { OAuthInterceptor } from './oauth.interceptor';

export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: LanguageInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: OAuthInterceptor, multi: true },
];